import { render, staticRenderFns } from "./ITextField.vue?vue&type=template&id=67453fef"
import script from "./ITextField.vue?vue&type=script&lang=js"
export * from "./ITextField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports